import { Tabs } from 'antd'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import LoadingIndicator from '../../components/loadingIndicator'
import NoDealsInfo from '../../components/noDealsInfo'
import PortfolioCard from '../../components/portfolioCard'
import Text from '../../components/text'
import { useAxios } from '../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { PORTFOLIO_FILTERS } from '../../core/constants'
import useOrdersToDisplay from '../../customhooks/useOrdersToDisplay'
import { fetchWalletAction } from '../financier/FinancierDuck'
import * as styles from './Portfolio.css'

export const Portfolio = () => {
  const {
    portfolioState: { query },
  } = useGlobal()
  const { financierDispatch } = useGlobalDispatch()
  const { authAxios } = useAxios()

  const observer = useRef()
  // completed is the Ongoing Transactions Tab
  const [selectedTab, setSelectedTab] = useState('completed')

  const [pageNumber, setPageNumber] = useState(1)
  const { orders, hasMore, loading, error } = useOrdersToDisplay(query, pageNumber, selectedTab)

  const handleTabChange = activeKey => {
    setPageNumber(1)
    setSelectedTab(PORTFOLIO_FILTERS[activeKey].state)
  }

  useEffect(() => {
    // On query change reset all
    setPageNumber(1)
  }, [query])

  useEffect(() => {
    fetchWalletAction()(authAxios, financierDispatch)
  }, [])

  // Callback increments PageNumber when last element is viewed
  const lastBookElementRef = useCallback(
    node => {
      if (loading) return
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber(prevPageNumber => prevPageNumber + 1)
        }
      })
      if (node) observer.current.observe(node)
    },
    [loading, hasMore, selectedTab]
  )

  return (
    <div className={styles.portfolioPage}>
      <div className={styles.pageHead}>
        <h1 className={styles.pageTitle}>Portfolio</h1>
      </div>
      <div className={styles.portfolioTabs}>
      <Tabs
        defaultActiveKey='0'
        onChange={handleTabChange}
        items={PORTFOLIO_FILTERS.map((filters, index) => ({
          label: filters?.title,
          key: index,
          children: (
            <>
              <div className={styles.orders}>
                {orders?.map((item, index) => {
                  if (orders?.length === index + 1) {
                    return (
                      <PortfolioCard
                        className={styles.order}
                        innerRef={lastBookElementRef}
                        key={item?.dealTransactionCode}
                        portfolio={item}
                        selectedTab={selectedTab}
                      />
                    )
                  } else {
                    return (
                      <PortfolioCard
                        className={styles.order}
                        key={item?.dealTransactionCode}
                        portfolio={item}
                        selectedTab={selectedTab}
                      />
                    )
                  }
                })}
              </div>
              {orders?.length === 0 && loading === false && (
                <NoDealsInfo description='Purchase deals to reflect in your portfolio.' />
              )}
              <div>{loading && <LoadingIndicator />}</div>
              <div>{error && <Text>{error}</Text>}</div>
            </>
          ),
        }))}
      />
      </div>
    </div>
  )
}
